import NiceModal from '@ebay/nice-modal-react';
import { UnstyledButton } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

import { useContentExitState } from './ContentExitContext';
import { ExitWithoutUploadModal } from './ExitWithoutUploadModal';

type Props = {
  hasQueue?: boolean;
  to?: string;
};

export const ContentBackLink = ({ hasQueue: hasQueueProp, to = '/content' }: Props) => {
  const navigate = useNavigate();
  const exitState = useContentExitState();
  const hasQueue = hasQueueProp ?? exitState.hasQueue;

  const handleClick = () => {
    if (hasQueue) {
      NiceModal.show(ExitWithoutUploadModal, {
        onConfirm: () => navigate(to),
      });
      return;
    }
    navigate(to);
  };

  return (
    <UnstyledButton
      onClick={handleClick}
      mb="md"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        color: 'var(--mantine-color-dimmed)',
        fontSize: 'var(--mantine-font-size-sm)',
      }}
    >
      <IconArrowLeft size={16} />
      Назад
    </UnstyledButton>
  );
};

export const useContentExit = (hasQueue: boolean, to = '/content') => {
  const navigate = useNavigate();

  return () => {
    if (hasQueue) {
      NiceModal.show(ExitWithoutUploadModal, {
        onConfirm: () => navigate(to),
      });
      return;
    }
    navigate(to);
  };
};
